import React from "react";
import { ListCommandButtons, type ListCommandButtonsProps } from "./list-command-buttons";
import type { RepositoryEloshieldClassicStationaryModules } from "src/domain/repositories/repository-eloshield-classic-stationary-modules";
import { observer } from "mobx-react";
import { makeObservable } from "mobx";
import { store } from "../../store";
import { FormCreateEloshieldClassicStationaryModule } from "../molecules/form-create-eloshield-classic-stationary-module";
import { FormUpdateEloshieldClassicStationaryModule } from "../molecules/form-update-eloshield-classic-stationary-module";

export type ListCommandButtonsEloshieldClassicStationaryModulesProps = Omit<
    ListCommandButtonsProps<RepositoryEloshieldClassicStationaryModules>,
    "list" | "createForm" | "listState"
>;

@observer
export class ListCommandButtonsEloshieldClassicStationaryModules extends React.Component<ListCommandButtonsEloshieldClassicStationaryModulesProps> {
    constructor(props: ListCommandButtonsEloshieldClassicStationaryModulesProps) {
        super(props);
        makeObservable(this);
    }

    public render(): JSX.Element {
        return (
            <ListCommandButtons<RepositoryEloshieldClassicStationaryModules>
                createForm={FormCreateEloshieldClassicStationaryModule}
                updateForm={FormUpdateEloshieldClassicStationaryModule}
                createButtonText={store.i18n.t(
                    "listEloshieldClassicStationaryModules.createButton.name",
                )}
                createDialogTitle={store.i18n.t(
                    "listEloshieldClassicStationaryModules.createDialog.title",
                )}
                updateDialogTitle={store.i18n.t(
                    "listEloshieldClassicStationaryModules.updateDialog.title",
                )}
                listState={store.serviceListStates.eloshieldClassicStationaryModules}
                {...this.props}
            />
        );
    }
}
